module.exports = __webpack_public_path__ + "img/sjbjgx.5ec51e73.png";